import IntersectionObserver from 'intersection-observer-polyfill';

export function visitOnScroll(targetDataAttr = 'data-has-visit') {
  const targets = document.querySelectorAll(`[${targetDataAttr}]`);

  targets.forEach((target) => {
    const observerThreshold =
      Number(target.getAttribute('data-observer-threshold')) || 1;

    const observer = new IntersectionObserver(observeFn, {
      threshold: observerThreshold,
    });

    observer.observe(target);
  });

  function observeFn(entries, observer) {
    const lastEntry = entries.pop();

    if (lastEntry.intersectionRatio > 0) {
      lastEntry.target.setAttribute(targetDataAttr, 'true');
      observer.unobserve(lastEntry.target);
    }
  }
}
